import React, { Fragment, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import PrintIcon from '@material-ui/icons/Print';
import Delete from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Modal from '../../../shared/components/Modal';
import ModalMat from '@material-ui/core/Modal';
import RepeatIcon from '@material-ui/icons/Repeat';
import { useEffect } from 'react';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ImageIcon from '@material-ui/icons/Image';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStream, faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import SwapVerticalCircleIcon from '@material-ui/icons/SwapVerticalCircle';
import Spinner from 'react-bootstrap/Spinner';
import ModalTemplatePdf from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/ModalTemplatePDF';
import AddPaymentToInvoice from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/AddPaymentToInvoice';
import FormAddRetention from '../../Retention/components/FormAddRetention';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import reciptPdf from './../../Admissions/SearchAdmissions/components/ReciptPdf'

const ReactTableActionsBillfold = ({ refresh, data, showDetailsInvoice }) => {

    const [isDelete, setIsdeleted] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [modalAlert, setModalAlert] = useState({ title: '', color: '', message: '' });
    const [showModalPayments, setShowModalPayments] = useState(false);
    const [loadingShowCreditNote, setLoadingShowCreditNote] = useState(false);
    const [openPDFCreditNote, setOpenPDFCreditNote] = useState(false);
    const [billing, setBilling] = useState(null);
    const [showModalRetentions, setShowModalRetentions] = useState(false);
    const [retentionsTypeList, setRetentionsTypeList] = useState(null);
    const [receipts, setReceipts] = useState(null);
    const profile = JSON.parse(sessionStorage.getItem('clinica'));



    useEffect(() => {
        console.log("COMINTOACTIOS", data);
        getRetentionsType();
        if (data.data.original.servicios !== null && data.data.original.servicios !== undefined) {

            const loadBilling = async () => {
                return new Promise((resolve, reject) => {
                    var dataBilling = { id_admision: data.data.original.servicios?.recibos_caja[0].id_admision };
                    console.log(dataBilling);
                    fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/admisionpaga', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                        },
                        body: JSON.stringify(dataBilling)
                    })
                        .then(response => {
                            return response.json();
                        })
                        .then(data => {
                            setBilling(data.contenido[0])
                            resolve(data.contenido[0]);
                        }).catch((e) => {
                            console.log(e);
                            reject(e);
                        });
                })
            }

            const loadReceipts = async () => {
                await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-recibos-por-admision?id_admision=' + data.data.original.servicios?.recibos_caja[0].id_admision, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    }
                }).then(response => {
                    return response.json();
                }).then(res => {
                    setReceipts(res);
                }).catch((error) => {
                    console.error('Error:', error);
                    setReceipts([]);
                });
            }

            loadBilling();
            loadReceipts();
            //setBilling(bill);  
        }
    }, []);

    const visualizarNotaCredito = async () => {
        setLoadingShowCreditNote(true);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/revisar-url-nota-credito?id_factura_t=${data.data.original.id_factura_t}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Error de Conexion con el Proveedor de Facturación Electronica');
            }
        }).then(data => {
            setLoadingShowCreditNote(false);
            setOpenPDFCreditNote(true);
            document.getElementById('pdfV').src = data.url_nota;
        }).catch(err => {
            setLoadingShowCreditNote(false);
            setOpenPDFCreditNote(true);
            //setShowAlertModalCreditNoteViewError(true);
            setOpenModal(true);
            setModalAlert({ title: 'Error', color: 'danger', message: 'Ha ocurrido un error de Conexión con el Proveedor de Facturación Electronica' });
            console.log(err);
        });
    }

    const onDelet = () => {
        setIsdeleted(false);
        //setIsLoading(true);
        let dataSend = { id_pago: data.data.original.id_pago };
        console.log(dataSend);
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/delete', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    console.log(response);
                    //refresh();
                    //getPaymentById(data.data.original.id_factura_t);
                    setModalAlert({ title: 'Acción completada', color: 'success', message: 'El pago fue eliminado' });
                    return response.json();
                })
                .then(data => {
                    resolve(true);
                })
                .catch((error) => {
                    resolve(error);
                });
        })
    }

    const onOkModal = () => {
        switch (modalAlert.color) {
            case "success":
                setOpenModal(!openModal);
                break;
            case "warning":
                onDelet();
                break;
            case "danger":
                setOpenModal(false)
                break;

        }
    }

    const loadPlan = async () => {
        return new Promise((resolve, reject) => {
            var dataClose = { id_plan: billing?.id_plan };
            fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar_plan', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataClose)
            }).then(response => {
                return response.json();
            }).then(data => {
                //loadDataProfile(billing, data.contenido[0], dataAdmision);
                resolve(data.contenido[0]);
            }).catch((e) => {
                console.log(e);
                reject(e);
            });
        })
    }

    const printReceiptData = async () => {
        let plan = await loadPlan();
        console.log("DEST", billing, plan, profile, receipts);
        setOpenModal(true);
        reciptPdf(billing, plan, profile, receipts);
    }

    const onToggleToWatchInvoiceDetails = (invoice) => {
        showDetailsInvoice(invoice);
    }

    const getRetentionsType = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'tipo-retencion/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                setRetentionsTypeList(data)
            })
            .catch((error) => {
                console.log(error)
            })
    };

    return (
        <Fragment>
            <td role="cell">
                {/* <Tooltip title="Ver Detalles">
                    <IconButton aria-label="edit" onClick={() => {
                        onToggleToWatchInvoiceDetails(data.data.original);
                    }}>
                        <ZoomInIcon />
                    </IconButton>
                </Tooltip> */}
                <Tooltip title="ver Recibo de Caja">
                    <IconButton aria-label="unable" style={{ padding: 2 }}
                        disabled={data.data.original.detalles_comerciales !== null}
                        onClick={() => {
                            printReceiptData();
                        }}>
                        <PrintIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Crear Retenciones a la Factura">
                    <IconButton
                        aria-label="print"
                        style={{ padding: 2 }}
                        onClick={() => {
                            setShowModalRetentions(true);
                        }}
                    >
                        <MoneyOffIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Generar Pago a la Factura">
                    <IconButton
                        aria-label="print"
                        style={{ padding: 2 }}
                        onClick={() => {
                            setShowModalPayments(true);
                        }}
                    >
                        <SwapVerticalCircleIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Visualizar Nota Crédito">
                    {loadingShowCreditNote ? (<Spinner style={{ width: '24px', height: '24px' }} animation="border" variant="success" />) :
                        <IconButton
                            disabled={data.data.original.folio_nota_credito == null ? true : false}
                            aria-label="print"
                            style={{ padding: 2 }}
                            onClick={() => {
                                visualizarNotaCredito(null)
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faFileInvoiceDollar}
                            />
                        </IconButton>}
                </Tooltip>
                {/* <Tooltip title="">
                    <IconButton aria-label="delete" onClick={() => {
                    }}>
                        <DeleteForeverIcon />
                    </IconButton>
                </Tooltip> */}
                {isDelete ?
                    <Modal
                        color={modalAlert.color}
                        title={modalAlert.title}
                        message={modalAlert.message}
                        modal={modalAlert}
                        onOk={() => onOkModal()}
                        toggle={() => { setModalAlert(!modalAlert) }}
                    />
                    : null}
            </td>
            {showModalPayments == true ?
                <Fragment>
                    <ModalMat
                        open={showModalPayments}
                        onClose={() => {
                            setShowModalPayments(false);
                        }}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ zIndex: 1000 }}
                    >
                        {/* <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '80%', margin: 10 }}> */}
                        <AddPaymentToInvoice selectedInvoice={data.data.original} />
                        {/* </div> */}
                    </ModalMat>
                </Fragment>
                : null
            }
            {
                showModalRetentions == true ?
                    <Fragment>
                        <ModalMat
                            open={showModalRetentions}
                            onClose={() => {
                                setShowModalRetentions(false);
                            }}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ zIndex: 1000 }}
                        >
                            <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '80%', margin: 10 }}>
                                <FormAddRetention selectedInvoice={data.data.original} retentionsTypeList={retentionsTypeList} />
                            </div>
                        </ModalMat>
                    </Fragment>
                    : null
            }
            <ModalTemplatePdf openModal={openPDFCreditNote} closeModal={() => setOpenPDFCreditNote(false)} />
        </Fragment>
    )
}

export default ReactTableActionsBillfold;